/**
 * gitHubConnection — RPC contract for the callable the backoffice asks
 * whether Revia's GitHub App can act on ReVia-Workspace/Revent.
 *
 * Cross-process contract between the backoffice (caller) and Revia's server
 * `gitHubConnection` handler (onCall). The caller holds `STAFF_PERMISSION` in
 * `workspaces/revia` with a second factor.
 *
 * Output, by `state`:
 *   connected     — the App's credentials are stored and it is installed on
 *                   the repository.
 *   not-installed — the App exists but is not installed on the repository;
 *                   `installUrl` opens its install page.
 *   not-connected — no App credentials are stored. `form` is GitHub's
 *                   "register a GitHub App from a manifest" request: a POST of
 *                   `manifest` to `action`, whose `state` query parameter is a
 *                   fresh one-hour token Revia's `gitHubAppCreated` callback
 *                   consumes once, so only a staff member's form can store an
 *                   App.
 */
import { z } from "zod";

export const GitHubConnectionInput = z.object({}).strict();
export type GitHubConnectionInput = z.infer<typeof GitHubConnectionInput>;

export const GitHubConnectionOutput = z.discriminatedUnion("state", [
	z.object({ state: z.literal("connected"), appSlug: z.string().min(1) }).strict(),
	z.object({ state: z.literal("not-installed"), appSlug: z.string().min(1), installUrl: z.url() }).strict(),
	z
		.object({
			state: z.literal("not-connected"),
			form: z.object({ action: z.url(), manifest: z.string().min(2) }).strict(),
		})
		.strict(),
]);
export type GitHubConnectionOutput = z.infer<typeof GitHubConnectionOutput>;
